<template>
    <div class="apprentice-simple-card las-settings">
        <div class="link-buttons-groups">
            <b-button
                @click="openModalLinkClass"
                variant="outline-primary"
                >{{ $t('group.settings.link_classes') }}
            </b-button>
            <b-button
                variant="primary"
                @click="setStudentData"
                >{{ $t('group.settings.set_up_papers') }}</b-button
            >
        </div>

        <design-2021-group-show-link-class-modal-component
            ref="class-link-modal"
            :group-in="groupIn"
            :reset-select-form="resetSelectForm"
            @linkGroup="linkModalGroup"
            @unLinkGroup="unLinkModalGroup"
            @formHasBeenReset="updateFormReset">
        </design-2021-group-show-link-class-modal-component>

        <design-2021-group-create-projects-modal-component
            ref="create-projects"
            :added-students-in="addedStudents"
            :updated-students-in="updatedStudents"
            @createProjects="createProjects">
        </design-2021-group-create-projects-modal-component>

        <div class="linked-groups">
            <div class="las-groups">
                <h4 class="title">{{ $t('group.settings.linked_classes') }}</h4>
                <design-2021-apprentice-data-table
                    v-if="linkedGroupsItems !== null"
                    nosearch
                    :fields="fields"
                    :items="linkedGroupsItems">
                    <template v-slot:cell(action)="data">
                        <b-button
                            class="btn-remove btn-remove-linked-las"
                            variant="danger-icon-only"
                            @click="unLinkGroup(data.item.id)">
                        </b-button>
                    </template>
                </design-2021-apprentice-data-table>

                <div
                    class="not-found with-header"
                    v-else>
                    <div
                        class="btn-add-circle icon"
                        @click="openModalLinkClass"></div>
                    <div class="alert-notice">{{ $t('group.settings.no_classes_linked') }}</div>
                </div>
            </div>

            <div class="las-main-groups">
                <h4 class="title">{{ $t('group.settings.linked_main_group') }}</h4>
                <design-2021-apprentice-data-table
                    v-if="linkedMainGroupsItems !== null"
                    nosearch
                    :fields="fields"
                    :items="linkedMainGroupsItems">
                    <template v-slot:cell(action)="data">
                        <b-button
                            class="btn-remove btn-remove-linked-group"
                            variant="danger-icon-only"
                            @click="unLinkMainGroup(data.item.id)">
                        </b-button>
                    </template>
                </design-2021-apprentice-data-table>

                <div
                    class="not-found with-header"
                    v-else>
                    <div
                        class="btn-add-circle icon"
                        @click="openModalLinkClass"></div>
                    <div class="alert-notice">{{ $t('group.settings.no_linked_main_groups') }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-show-link-component',
    props: {
        groupIn: Object,
    },
    data() {
        return {
            group: this.groupIn,
            linkedLasGroups: null,
            linkedLasMainGroups: null,
            fields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
            resetSelectForm: false,
            lasGroups: null,
            lasMainGroups: null,
            addedStudents: [],
            updatedStudents: [],
        };
    },
    methods: {
        createProjects() {
            this.alert
                .confirm(
                    this.$t('group.set_up_papers'),
                    this.$t(
                        'group.settings.you_will_now_create_an_assignment_for_each_student_who_is_linked_to_this_group_and_does_not_yet_have_an_assignment',
                    ),
                    this.$t('group.settings.process'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }

                    this.alert.saving();

                    this.axios.post(this.routes.groupLasCreateProjects(this.groupIn.id)).then(
                        (response) => {
                            this.alert.success();
                            location.reload();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },
        setStudentData() {
            this.alert.loading();

            this.axios.get(this.routes.groupLasShowChanges(this.groupIn.id)).then(
                (response) => {
                    this.alert.loaded();

                    let data = {
                        added: response.data.addedStudents,
                        updated: response.data.updatedStudents,
                    };

                    this.showCreateModal(data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );

            if (this.addedStudents.length !== 0 || this.updatedStudents.length !== 0) {
                this.showCreateModal();
            }
        },
        showCreateModal(data) {
            this.$refs['create-projects'].show(data);
        },
        openModalLinkClass() {
            this.$refs['class-link-modal'].show();
            // this.$bvModal.show('class-link-modal');
        },

        unLinkGroup(id) {
            this.alert
                .confirm(
                    this.$t('group.settings.disconnect'),
                    this.$t('group.settings.are_you_sure_you_want_to_disconnect_this_class'),
                    this.$t('group.settings.disconnect'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    this.alert.saving();
                    this.axios.delete(this.routes.groupLasGroup(this.group.id, id)).then(
                        (response) => {
                            this.group.las_groups = this.group.las_groups.filter((g) => g.id !== id);
                            this.resetSelectForm = false;

                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },

        unLinkMainGroup(id) {
            this.alert
                .confirm(
                    this.$t('group.settings.disconnect'),
                    this.$t('group.settings.are_you_sure_you_want_to_disconnect_this_main_group'),
                    this.$t('group.settings.disconnect'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    this.alert.saving();
                    this.axios.delete(this.routes.groupLasMainGroup(this.group.id, id)).then(
                        (response) => {
                            this.group.las_main_groups = this.group.las_main_groups.filter((g) => g.id !== id);
                            this.resetSelectForm = false;

                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },

        linkGroup(lasGroupId) {
            this.alert.saving();
            this.axios.post(this.routes.groupLasGroup(this.group.id, lasGroupId)).then(
                (response) => {
                    this.group.las_groups.push(response.data);
                    this.resetSelectForm = true;
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        linkMainGroup(lasGroupId) {
            this.alert.saving();
            this.axios.post(this.routes.groupLasMainGroup(this.group.id, lasGroupId)).then(
                (response) => {
                    this.group.las_main_groups.push(response.data);
                    this.resetSelectForm = true;
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        linkModalGroup(lasGroupId, linkType) {
            if (linkType === 1) {
                this.linkGroup(lasGroupId);
            }

            if (linkType === 2) {
                this.linkMainGroup(lasGroupId);
            }
        },

        unLinkModalGroup(lasGroupId, linkType) {
            if (linkType === 1) {
                this.unLinkGroup(lasGroupId);
            }

            if (linkType === 2) {
                this.unLinkMainGroup(lasGroupId);
            }
        },

        updateFormReset(value) {
            this.resetSelectForm = !value;
        },
    },
    computed: {
        linkedGroupsItems() {
            if (this.group.las_groups.length) {
                return this.group.las_groups.map((lasGroup) => {
                    return {
                        name: lasGroup.name,
                        id: lasGroup.id,
                    };
                });
            }
            return null;
        },

        linkedMainGroupsItems() {
            if (this.group.las_main_groups.length && typeof this.group.las_main_groups == 'object' ) {
                return this.group.las_main_groups.map((lasMainGroup) => {
                    return {
                        name: lasMainGroup.name,
                        id: lasMainGroup.id,
                    };
                });
            }
            return null;
        },
    },

    watch: {
        groupIn: function (value) {
            this.group = value;
        },

        group: function (value) {
            this.group = value;
        },
    },
};
</script>

<style scoped lang="scss">
.icon {
    &:before {
        margin-right: 0;
    }

    &:hover {
        cursor: pointer;
    }
}

.las-settings {
    display: flex;
    flex-direction: column;

    .btn:first-child {
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
    }
}

.link-buttons-groups {
    display: flex;
    flex-direction: column;
    align-self: flex-end;
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.linked-groups {
    display: flex;
    flex-direction: column;

    .title {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .not-found {
        margin-top: map-get($grid-gutter-spacing, 'twenty-one') * 2;
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .las-settings {
        justify-content: flex-end;
    }

    .link-buttons-groups {
        flex-direction: row;
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

        .btn:first-child {
            margin-bottom: 0;
            margin-right: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .linked-groups {
        flex-direction: row;
        justify-content: space-between;
    }

    .las-groups,
    .las-main-groups {
        flex: 0.45;
    }
}
</style>
